import ExpandMore from '@mui/icons-material/ExpandMore';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Link from '@mui/material/Link';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import { styled } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import React, { useState } from 'react';
import { isValidUrl } from '../../../../utils/url-utils';

const PREFIX = 'DocumentsContent';

const classes = {
  documentsHeader: `${PREFIX}-documentsHeader`,
  documentList: `${PREFIX}-documentList`,
  documentLink: `${PREFIX}-documentLink`
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')(({ theme }) => ({
  [`& .${classes.documentsHeader}`]: {
    paddingLeft: theme.spacing(2)
  },

  [`& .${classes.documentList}`]: {
    marginTop: 5
  },

  [`& .${classes.documentLink}`]: {
    marginTop: -15
  }
}));

export interface Document {
  name: string;
  link: string;
}

interface DocumentsProps {
  documents?: Document[];
}

const DocumentsContent = ({ documents = [] }: DocumentsProps) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(true);

  const iconOnClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();
    setIsExpanded(!isExpanded);
  };

  return documents.length > 0 ? (
    <Root>
      <Typography
        className={classes.documentsHeader}
        variant="subtitle1"
        color="primary"
        data-testid="documents-header"
      >
        Documents
        <Tooltip title={isExpanded ? 'Collapse' : 'Expand'}>
          <IconButton size="small" aria-label="expand-documents" onClick={iconOnClick}>
            <ExpandMore transform={isExpanded ? 'rotate(180)' : 'rotate(0)'} />
          </IconButton>
        </Tooltip>
      </Typography>
      <Collapse
        data-testid="expanded-group"
        in={isExpanded}
        timeout={{ enter: 200, exit: 250 }}
        unmountOnExit
      >
        <List disablePadding data-testid="documents-list" className={classes.documentList}>
          {documents.map((entry: Document) => {
            if (!isValidUrl(entry.link)) return null;

            return (
              <ListItem key={entry.name}>
                <Link
                  data-testid="document-link"
                  href={entry.link}
                  target="_blank"
                  variant="body2"
                  className={classes.documentLink}
                >
                  {entry.name}
                </Link>
              </ListItem>
            );
          })}
        </List>
      </Collapse>
    </Root>
  ) : null;
};

export default DocumentsContent;
